// material-ui

import boxtrailer from '../../../assets/images/Trailer/box-trailer.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const BoxTrailer = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={boxtrailer} alt="Box Trailer" height={props.height || 30} width={props.width || 70} />
    );
};

export default BoxTrailer;